const _excluded = ["icon", "className", "iconClassName", "active", "color", "filled", "count", "emoji", "text"];
var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/status-action-button.tsx";

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import classNames from 'clsx';
import React from 'react';
import { Text, Icon, Emoji } from 'soapbox/components/ui';
import { shortNumberFormat } from 'soapbox/utils/numbers';
const COLORS = {
  accent: 'accent',
  success: 'success'
};

/** Action button numerical counter, eg "5" likes. */
const StatusActionCounter = _ref => {
  let {
    count = 0
  } = _ref;
  return /*#__PURE__*/React.createElement(Text, {
    size: "xs",
    weight: "semibold",
    theme: "inherit",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21,
      columnNumber: 5
    }
  }, shortNumberFormat(count));
};

const StatusActionButton = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    icon,
    className,
    iconClassName,
    active,
    color,
    filled = false,
    count = 0,
    emoji,
    text
  } = props,
        filteredProps = _objectWithoutProperties(props, _excluded);

  const renderIcon = () => {
    if (emoji) {
      return /*#__PURE__*/React.createElement("span", {
        className: "flex w-6 h-6 items-center justify-center",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 44,
          columnNumber: 9
        }
      }, /*#__PURE__*/React.createElement(Emoji, {
        className: "w-full h-full p-0.5",
        emoji: emoji,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 45,
          columnNumber: 11
        }
      }));
    } else {
      return /*#__PURE__*/React.createElement(Icon, {
        src: icon,
        className: classNames({
          'fill-accent-300 hover:fill-accent-300': active && filled && color === COLORS.accent
        }, iconClassName),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 50,
          columnNumber: 9
        }
      });
    }
  };

  const renderText = () => {
    if (text) {
      return /*#__PURE__*/React.createElement(Text, {
        tag: "span",
        theme: "inherit",
        size: "sm",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 66,
          columnNumber: 9
        }
      }, text);
    } else if (count) {
      return /*#__PURE__*/React.createElement(StatusActionCounter, {
        count: count,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 72,
          columnNumber: 9
        }
      });
    }
  };

  return /*#__PURE__*/React.createElement("button", _extends({
    ref: ref,
    type: "button",
    className: classNames('flex items-center p-1 rounded-full', 'text-gray-600 hover:text-gray-600 dark:hover:text-white', 'bg-white dark:bg-transparent', 'focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 dark:ring-offset-0', {
      'text-black dark:text-white': active && emoji,
      'text-accent-300 hover:text-accent-300 dark:hover:text-accent-300': active && !emoji && color === COLORS.accent,
      'text-success-600 hover:text-success-600 dark:hover:text-success-600': active && !emoji && color === COLORS.success,
      'space-x-1': !text,
      'space-x-2': text
    }, className)
  }, filteredProps, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 78,
      columnNumber: 5
    }
  }), renderIcon(), renderText());
});
export default StatusActionButton;